import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import WarningIcon from 'apps/web_forms/assets/warning.svg';

const StyledContainer = styled.div`
  display: flex;
  font-size: 0.8em;
  label {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.5em;
  }
  .icon {
    height: 3em;
    width: 2.5em;
  }
`;

const NfcInput = ({ element }) => {
  const { title, identifier } = element;

  return (
    <div className="react-form-control">
      <label htmlFor={identifier}>{title}</label>

      <StyledContainer>
        <div className="icon">
          <WarningIcon />
        </div>
        <label>
          NFC Questions are not supported in the Web Forms app. Please use the
          mobile app to fill out this form.
        </label>
      </StyledContainer>
    </div>
  );
};

NfcInput.propTypes = {
  element: PropTypes.shape({
    identifier: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default NfcInput;
